module.exports = __webpack_public_path__ + "static/splash-3-f6eb0e3bb20a73163df4d14f9c772d75.jpg";